<template>
  <div class="cx_barcode_setting">  
      <div>
            <div class="cx_barcode_setting_item">
                <div class="cx_barcode_caption" tabindex="-1">カウントアップ方法<i   class="material-symbols-outlined  small valign help" ref="tooltip_target1">help_outline</i></div>
                <toggle-button v-model="autoCountUp" sync :labels="{checked:'自動', unchecked:'手動'}" :width="80" :font-size="11" color="#0761AB"/>
            </div>    
            <div class="cx_barcode_setting_item">
                <div class="cx_barcode_caption" tabindex="-1">検品済み伝票の表示<i   class="material-symbols-outlined small valign help" ref="tooltip_target2">help_outline</i></div>
                <toggle-button v-model="showCompletedVoucher" sync :labels="{checked:'表示', unchecked:'非表示'}" :width="80" :font-size="11" color="#0761AB"/>
            </div>
            <div class="cx_barcode_setting_item" v-if="cameraEnabled">
            <div class="cx_barcode_caption" tabindex="-1">読取デバイス<i   class="material-symbols-outlined small valign help" ref="tooltip_target3">help_outline</i></div>
            <toggle-button v-model="readerEnabled" sync :labels="{checked:'スキャナ', unchecked:'カメラ'}" :width="80" :font-size="11" color="#0761AB"/>
            </div>
            <div class="cx_barcode_setting_item">
                <div class="cx_barcode_caption" tabindex="-1">検品モード<i   class="material-symbols-outlined small valign help" ref="tooltip_target4">help_outline</i></div>
                <toggle-button v-model="isEnabledOrderInspection" sync :labels="{checked:'受発注検品', unchecked:'入出荷検品'}" :width="90" :font-size="11" color="#0761AB"/>
            </div>
      </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class BarcodeSetting extends Vue {

    autoCountUp: boolean=false;
    showCompletedVoucher:boolean= false;
    readerEnabled:boolean = false;
    isEnabledOrderInspection: boolean = false;
    cameraEnabled:boolean = false;

    mounted(){        
      this.autoCountUp =  localStorage['autoCountUp'] != 'false'; //初期値はtrue
      this.showCompletedVoucher =  localStorage['showCompletedVoucher'] == 'true'; //初期値はfalse      
      this.readerEnabled =  localStorage['readerEnabled'] != 'false'; //初期値はtrue
      this.isEnabledOrderInspection =  localStorage['isEnabledOrderInspection'] == 'true'; //初期値はfalse

      //毎回初期化する(ライセンスの状況が同じとは限らない)
      navigator.mediaDevices.enumerateDevices().then(devices =>{
        //カメラデバイスがあり検品デバイス数が設定されている場合にカメラゾーンを有効化する
        this.cameraEnabled = devices.filter((device) => device.kind === 'videoinput').length > 0 && this.$api.license.hasScannerLicense;
        this.$nextTick(()=>{
            this.$api.tooltip.mount(this, this.$refs.tooltip_target1 as Element,"バーコード読取時に自動でカウントアップするかどうかを指定します。");         
            this.$api.tooltip.mount(this, this.$refs.tooltip_target2 as Element,"検品済み伝票を表示するかどうかを指定します。");        
            this.$api.tooltip.mount(this, this.$refs.tooltip_target3 as Element,"バーコード読取を背面カメラで行うか外部スキャナで行うかを指定します。");   
            this.$api.tooltip.mount(this, this.$refs.tooltip_target4 as Element,"入出荷検品と受発注検品のどちらを行うかを指定します。"); 
        });        
      });      
                                
    }
  @Watch('readerEnabled')
  public onReaderEnabledChanged() {
    localStorage['readerEnabled'] = this.readerEnabled;
  }
  @Watch('showCompletedVoucher')
  public onShowCompletedVoucherChanged() {
    localStorage['showCompletedVoucher'] = this.showCompletedVoucher;      
  }  
  @Watch('autoCountUp')
  public onAutoCountUpChanged() {
    localStorage['autoCountUp'] = this.autoCountUp;      
  }
  @Watch('isEnabledOrderInspection')
  public onIsEnabledOrderInspectionChanged() {
    localStorage['isEnabledOrderInspection'] = this.isEnabledOrderInspection;
  }
}
</script>
<style lang="scss">
@import '@/agiles/components/style.scss';
.cx_barcode_setting{
    width: 100%;
    height: 100%;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .cx_barcode_setting_item{
        margin: 10px 0px;
        display: flex;
        align-items: center;        
        label {
            margin-bottom: unset;
        }
    }
    .cx_barcode_caption{
        display: flex;
        text-align: left;
        width : 250px;
        height: 32px;
        margin-left:5px;
        align-items: center;
        i {
        margin-left:2px;
        margin-bottom:0px;
        margin-right:0px;
        font-size: 24px ;
        color:#9e9d9d;      

            &:hover{
                color:#007bff;                
                cursor:pointer;
            }      

        }          
    }
}
</style>